import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { Helmet } from "react-helmet";
import { Row, Col, Button } from "reactstrap";

import RemovalTable from "./../../components/page/production/removal/RemovalTable";
import EditRemovalModal from "./../../components/page/production/removal/EditRemovalModal";
import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  modalShow: false,
  modalData: [],
  modalEdit: false,
  tableNeedsRefresh: true,
  modalTitle: 'Edit Removal'
};

class RemovalsPage extends Component {

  state = initialState;

  constructor(props){
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  };

  openModal(modal) {
   this.setState({
     modalShow: true,
     modalData: modal.data,
     modalEdit: true,
     tableNeedsRefresh: false,
     modalTitle: modal.title
   })
 };
  closeModal(dataChanged) {
    this.setState({
      modalShow: false,
    });
    if (dataChanged){
      this.setState({
        tableNeedsRefresh: true,
      });
    }
  };

  render() {

    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin | Production</title>
        </Helmet>
        <Col md={12}>
          <Title style={{ marginBottom: 16 }}>Removals</Title>
          <RemovalTable toggleHandler = {this.openModal} needsRefresh = {this.state.tableNeedsRefresh} />
          <EditRemovalModal toggleHandler = {this.closeModal} title={this.state.modalTitle} show={this.state.modalShow} data={this.state.modalData} edit={this.state.modalEdit} />
        </Col>
      </Fragment>
    );
    }
}

export default withRouter(RemovalsPage);
